module.exports = __webpack_public_path__ + "img/video.de00779e.png";